document.addEventListener('alpine:init', () => {
  Alpine.data('predictiveSearch', () => ({
    query: '',
    results: { products: [], collections: [] },
    loading: false,
    error: '',
    open: false,
    activeIndex: -1,
    debounceTimer: null,
    abortController: null,
    _fetchTimeout: null,
    _timedOut: false,
    _currencyCode: null,
    _currencyFormatter: null,

    init() {
      this._currencyCode = document.body.dataset.shopCurrency || 'USD';
      try {
        this._currencyFormatter = new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: this._currencyCode
        });
      } catch (e) {
        this._currencyFormatter = null;
      }
    },

    onInput() {
      clearTimeout(this.debounceTimer);
      this.error = '';
      if (this.query.length < 2) {
        this.results = { products: [], collections: [] };
        this.loading = false;
        this.close();
        return;
      }
      this.loading = true;
      this.debounceTimer = setTimeout(() => this.fetchResults(), 300);
    },

    announce(message) {
      var el = document.getElementById('sr-announcer');
      if (el) { el.textContent = ''; requestAnimationFrame(function () { el.textContent = message; }); }
    },

    announceAssertive(message) {
      var el = document.getElementById('sr-announcer-assertive');
      if (el) { el.textContent = ''; requestAnimationFrame(function () { el.textContent = message; }); }
    },

    async fetchResults() {
      if (this.abortController) this.abortController.abort();
      this.abortController = new AbortController();
      if (this._fetchTimeout) clearTimeout(this._fetchTimeout);
      this._timedOut = false;
      var self = this;
      this._fetchTimeout = setTimeout(function () { self._timedOut = true; self.abortController.abort(); }, 10000);
      this.error = '';

      try {
        const params = new URLSearchParams({
          q: this.query,
          'resources[type]': 'product,collection',
          'resources[limit]': '6',
          'resources[options][unavailable_products]': 'hide'
        });
        const res = await fetch(`/search/suggest.json?${params}`, {
          signal: this.abortController.signal
        });
        if (!res.ok) {
          var httpErr = new Error('HTTP ' + res.status);
          httpErr.status = res.status;
          throw httpErr;
        }
        var data;
        try {
          data = await res.json();
        } catch (parseErr) {
          var jsonErr = new Error('Parse error');
          jsonErr.parseFailure = true;
          throw jsonErr;
        }
        const r = data.resources.results;
        this.results = {
          products: r.products || [],
          collections: r.collections || []
        };
        this.open = true;
        this.activeIndex = -1;
        var count = this.resultCount;
        if (count > 0) {
          this.announce(count + ' search ' + (count === 1 ? 'result' : 'results') + ' available.');
        } else {
          this.announce('No search results found.');
        }
      } catch (e) {
        if (e.name === 'AbortError') {
          if (this._timedOut) {
            this.error = 'Search timed out. Please try again.';
            this.results = { products: [], collections: [] };
            this.open = true;
            this.activeIndex = -1;
            this.announceAssertive(this.error);
          }
          return;
        }
        if (e.status && e.status >= 500) {
          this.error = 'Search temporarily unavailable';
        } else if (e.parseFailure) {
          this.error = 'Something went wrong. Please try again.';
        } else {
          this.error = 'Search unavailable, please try again';
        }
        this.results = { products: [], collections: [] };
        this.open = true;
        this.activeIndex = -1;
        this.announceAssertive(this.error);
      } finally {
        clearTimeout(this._fetchTimeout);
        this.loading = false;
      }
    },

    clear() {
      clearTimeout(this.debounceTimer);
      clearTimeout(this._fetchTimeout);
      if (this.abortController) this.abortController.abort();
      this.query = '';
      this.results = { products: [], collections: [] };
      this.loading = false;
      this.error = '';
      this.open = false;
      this.activeIndex = -1;
    },

    close() {
      this.open = false;
      this.activeIndex = -1;
    },

    get resultCount() {
      return this.results.products.length + this.results.collections.length;
    },

    get allItems() {
      const items = [];
      this.results.products.forEach((p, i) => items.push({ type: 'product', index: i, url: p.url }));
      this.results.collections.forEach((c, i) => items.push({ type: 'collection', index: i, url: c.url }));
      if (this.resultCount > 0) items.push({ type: 'viewall', url: `/search?q=${encodeURIComponent(this.query)}` });
      return items;
    },

    navigate(dir) {
      const total = this.allItems.length;
      if (total === 0) return;
      this.activeIndex = (this.activeIndex + dir + total) % total;
    },

    selectActive() {
      if (this.activeIndex >= 0 && this.activeIndex < this.allItems.length) {
        window.location.href = this.allItems[this.activeIndex].url;
      } else {
        this.$el.closest('form')?.submit();
      }
    },

    isActive(type, index) {
      const item = this.allItems[this.activeIndex];
      return item && item.type === type && item.index === index;
    },

    isViewAllActive() {
      const item = this.allItems[this.activeIndex];
      return item && item.type === 'viewall';
    },

    formatPrice(price) {
      if (this._currencyFormatter) {
        return this._currencyFormatter.format(parseFloat(price));
      }
      return (this._currencyCode || 'USD') + ' ' + parseFloat(price).toFixed(2);
    }
  }));
});
